var _radialGradient, _radialGradient2, _radialGradient3, _linearGradient, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _linearGradient2, _linearGradient3, _radialGradient8, _radialGradient9, _linearGradient4, _radialGradient10, _radialGradient11, _linearGradient5, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _radialGradient19, _radialGradient20, _radialGradient21, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _radialGradient22, _linearGradient10, _radialGradient23, _radialGradient24, _radialGradient25, _radialGradient26, _linearGradient11, _radialGradient27, _radialGradient28, _radialGradient29, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconZebra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 145.014,
    cy: 51.749,
    gradientTransform: "matrix(-.538 -.843 .578 -.369 193.124 193.069)",
    gradientUnits: "userSpaceOnUse",
    r: 38.413
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6c1c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4906,
    stopColor: "#c8c3ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7484,
    stopColor: "#cfcbd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9519,
    stopColor: "#dbd9de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfdde2"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 141.958,
    cy: 46.176,
    gradientTransform: "matrix(-.705 -.71 .708 -.703 209.265 179.393)",
    gradientUnits: "userSpaceOnUse",
    r: 37.848
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b818e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#837985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#6c646e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9757,
    stopColor: "#474247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454045"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 313.241,
    cy: 2182.417,
    gradientTransform: "matrix(.931 0 0 .112 -31.713 241.019)",
    gradientUnits: "userSpaceOnUse",
    r: 273.211
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6c1c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2432,
    stopColor: "#dddbdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    stopColor: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6632,
    stopColor: "#fafafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8642,
    stopColor: "#fff"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9902,
    stopColor: "#dfdde2"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 87.074,
    cy: 60.494,
    gradientTransform: "matrix(1 0 0 .685 0 19.051)",
    gradientUnits: "userSpaceOnUse",
    r: 60.79,
    xlinkHref: "#lg1"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 167.141,
    cy: 107.834,
    gradientTransform: "matrix(-.204 -.979 .669 -.139 129.088 286.496)",
    gradientUnits: "userSpaceOnUse",
    r: 89.141
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#544f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2057,
    stopColor: "#5d5860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    stopColor: "#77707a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9828,
    stopColor: "#a096a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a298a5"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 74.729,
    cy: 20.605,
    gradientTransform: "matrix(1 0 0 .685 0 6.489)",
    gradientUnits: "userSpaceOnUse",
    r: 93.506,
    xlinkHref: "#lg1"
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 32.197,
    cy: 76.353,
    gradientTransform: "matrix(-.705 -.71 .708 -.703 .792 152.905)",
    gradientUnits: "userSpaceOnUse",
    r: 77.564
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7ecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5673,
    stopColor: "#b1adb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b818e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(.889 0 0 .866 111.417 -303.21)",
    gradientUnits: "userSpaceOnUse",
    x1: 314.497,
    x2: 237.362,
    y1: 830.131,
    y2: 800.16
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3708,
    stopColor: "#afaab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#aba6b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5298,
    stopColor: "#a19aa5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6097,
    stopColor: "#8f8692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#8b818e"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.274,
    x2: 183.977,
    y1: 436.739,
    y2: 383.072
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    stopColor: "#afaab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7359,
    stopColor: "#aaa5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8708,
    stopColor: "#9d96a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b818e"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 169.72,
    cy: 302.65,
    gradientTransform: "matrix(.575 -.818 .645 .453 -123.154 304.327)",
    gradientUnits: "userSpaceOnUse",
    r: 96.468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1922,
    stopColor: "#8b818e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2156,
    stopColor: "#8d8390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#a099a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7542,
    stopColor: "#aba6b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afaab4"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 330.436,
    cy: 281.208,
    gradientTransform: "matrix(.86 .511 -.403 .678 159.732 -78.284)",
    gradientUnits: "userSpaceOnUse",
    r: 86.728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3347,
    stopColor: "#8b818e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6667,
    stopColor: "#a099a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#afaab4"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#544f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5487,
    stopColor: "#69636c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#756e78"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 1584.301,
    cy: 482.254,
    gradientTransform: "matrix(-.872 -.403 -.323 .771 1697.725 749.183)",
    gradientUnits: "userSpaceOnUse",
    r: 29.129,
    xlinkHref: "#lg2"
  })), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 1527.873,
    cy: 482.254,
    gradientTransform: "matrix(-.872 -.403 -.323 .771 1702.284 726.439)",
    gradientUnits: "userSpaceOnUse",
    r: 29.129,
    xlinkHref: "#lg2"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2425,
    stopColor: "#cfcbd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7242,
    stopColor: "#a59ea8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b818e"
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 180.768,
    cy: 465.817,
    gradientTransform: "matrix(-.862 -.506 .312 -.532 191.124 805.175)",
    gradientUnits: "userSpaceOnUse",
    r: 27.125,
    xlinkHref: "#lg3"
  })), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 1360.736,
    cy: 482.254,
    gradientTransform: "matrix(-.872 -.403 -.323 .771 1715.788 659.072)",
    gradientUnits: "userSpaceOnUse",
    r: 30.849,
    xlinkHref: "#lg2"
  })), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 1304.309,
    cy: 482.254,
    gradientTransform: "matrix(-.872 -.403 -.323 .771 1720.347 636.328)",
    gradientUnits: "userSpaceOnUse",
    r: 30.849,
    xlinkHref: "#lg2"
  })), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 391.925,
    cy: 465.817,
    gradientTransform: "matrix(-.862 -.506 .312 -.532 584.368 912.097)",
    gradientUnits: "userSpaceOnUse",
    r: 27.125,
    xlinkHref: "#lg3"
  })), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 48.465,
    cy: 1590.794,
    gradientTransform: "matrix(.631 0 0 .554 388.105 -629.984)",
    gradientUnits: "userSpaceOnUse",
    r: 172.045
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#a298a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4932,
    stopColor: "#b4acb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfdde2"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 261.382,
    cy: 142.574,
    gradientTransform: "matrix(1 0 0 .84 0 22.869)",
    gradientUnits: "userSpaceOnUse",
    r: 240.071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3027,
    stopColor: "#dedce1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7527,
    stopColor: "#c6c1c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a298a5"
  }))), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 252.015,
    cy: 161.489,
    gradientTransform: "matrix(-.862 -.506 .312 -.532 418.883 375.014)",
    gradientUnits: "userSpaceOnUse",
    r: 175.677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6c1c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2648,
    stopColor: "#b5afb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7909,
    stopColor: "#88828b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#756e78"
  }))), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: 128.732,
    cy: 207.058,
    gradientTransform: "matrix(1 0 0 .84 0 33.213)",
    gradientUnits: "userSpaceOnUse",
    r: 230.066
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3264,
    stopColor: "#dfdce0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    stopColor: "#c6c1c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7546,
    stopColor: "#c3bec5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    stopColor: "#bbb4bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9534,
    stopColor: "#aca3af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a298a5"
  }))), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_22_",
    cx: 112.944,
    cy: 196.643,
    gradientTransform: "matrix(-.57 -.822 .507 -.352 77.616 358.591)",
    gradientUnits: "userSpaceOnUse",
    r: 119.305
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2495,
    stopColor: "#e1dfe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    stopColor: "#b9b2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a298a5"
  }))), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_23_",
    cx: 138.979,
    cy: 128.23,
    gradientTransform: "matrix(1 0 0 .84 0 20.569)",
    gradientUnits: "userSpaceOnUse",
    r: 114.196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a298a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4356,
    stopColor: "#c6c1c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7202,
    stopColor: "#d5d1d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfdde2"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.019,
    x2: 237.722,
    y1: 436.739,
    y2: 383.072
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    stopColor: "#c6c1c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#c1bcc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9702,
    stopColor: "#b2adb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afaab4"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.27,
    x2: 205.27,
    y1: 472.233,
    y2: 388.111
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2231,
    stopColor: "#dfdde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    stopColor: "#d5d2d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9331,
    stopColor: "#c6c1c8"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(.889 0 0 .866 111.417 -303.21)",
    gradientUnits: "userSpaceOnUse",
    x1: 381.614,
    x2: 282.99,
    y1: 851.303,
    y2: 744.754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2188,
    stopColor: "#afaab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afaab4"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.979,
    x2: 415.979,
    y1: 363.613,
    y2: 465.413
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b818e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1486,
    stopColor: "#9e96a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3028,
    stopColor: "#aba5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4304,
    stopColor: "#afaab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9777,
    stopColor: "#c6c1c8"
  }))), _radialGradient22 || (_radialGradient22 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_28_",
    cx: 194.433,
    cy: 243.171,
    gradientTransform: "matrix(.575 -.818 .645 .453 -74.261 292.035)",
    gradientUnits: "userSpaceOnUse",
    r: 238.128
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#c6c1c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8265,
    stopColor: "#b8b3bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afaab4"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.149,
    x2: 138.149,
    y1: 268.908,
    y2: 268.908
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0457,
    stopColor: "#ffdace"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#facab7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2134,
    stopColor: "#f0a987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3168,
    stopColor: "#e89164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4013,
    stopColor: "#e4824f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4565,
    stopColor: "#e27d47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7264,
    stopColor: "#e06b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    stopColor: "#dd542e"
  }))), _radialGradient23 || (_radialGradient23 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_30_",
    cx: 199.99,
    cy: 294.741,
    gradientTransform: "matrix(.962 .273 -.28 .987 90.25 -50.684)",
    gradientUnits: "userSpaceOnUse",
    r: 107.65
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1107,
    stopColor: "#f5f5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4101,
    stopColor: "#dfdde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6554,
    stopColor: "#cecbd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afaab4"
  }))), _radialGradient24 || (_radialGradient24 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_31_",
    cx: 315.306,
    cy: 230.652,
    gradientTransform: "matrix(.912 -.411 .324 .719 -46.905 194.44)",
    gradientUnits: "userSpaceOnUse",
    r: 204.526
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#c6c1c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8265,
    stopColor: "#b8b3bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afaab4"
  }))), _radialGradient25 || (_radialGradient25 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_32_",
    cx: 344.122,
    cy: 238.545,
    gradientTransform: "matrix(.962 .273 -.28 .987 79.985 -90.846)",
    gradientUnits: "userSpaceOnUse",
    r: 157.534
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3656,
    stopColor: "#c5c2ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5893,
    stopColor: "#afaab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a298a5"
  }))), _radialGradient26 || (_radialGradient26 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_33_",
    cx: 165.941,
    cy: 51.749,
    gradientTransform: "matrix(-.538 -.843 .578 -.369 225.306 210.711)",
    gradientUnits: "userSpaceOnUse",
    r: 38.413
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6c1c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2484,
    stopColor: "#d5d2d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    stopColor: "#dfdde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7574,
    stopColor: "#e1dfe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9071,
    stopColor: "#e8e7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f1f4"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a298a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    stopColor: "#a096a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6067,
    stopColor: "#998f9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7408,
    stopColor: "#8c848f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#7b737e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    stopColor: "#645e67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f57"
  }))), _radialGradient27 || (_radialGradient27 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_34_",
    cx: 162.885,
    cy: 46.176,
    gradientTransform: "matrix(-.705 -.71 .708 -.703 244.936 194.244)",
    gradientUnits: "userSpaceOnUse",
    r: 37.848,
    xlinkHref: "#lg4"
  })), _radialGradient28 || (_radialGradient28 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_35_",
    cx: 147.274,
    cy: 234.977,
    gradientTransform: "matrix(.836 -.549 .376 .573 -65.484 43.311)",
    gradientUnits: "userSpaceOnUse",
    r: 80.043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4906,
    stopColor: "#dddbe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7484,
    stopColor: "#d6d3d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9519,
    stopColor: "#cac5cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6c1c8"
  }))), _radialGradient29 || (_radialGradient29 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_36_",
    cx: 134.749,
    cy: 257.447,
    gradientTransform: "matrix(-.546 -.838 .837 -.545 -12.66 369.693)",
    gradientUnits: "userSpaceOnUse",
    r: 65.586,
    xlinkHref: "#lg4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m147.067 52.488h-18.016l-3-51.485c0-.847.986-1.312 1.639-.773l2.428 2.004c10.733 8.856 16.948 22.044 16.948 35.959v14.295z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.051 1.004v44.227h11.088v-14.295c0-11.132-3.978-21.798-11.064-30.154-.016.071-.024.145-.024.222z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 512c123.539 0 223.688-12.27 223.688-27.405h-447.376c0 15.135 100.149 27.405 223.688 27.405z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.92 66.77-19.304 6.905 70.256 7.005 5.528-20.915z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.475 186.549 3.848-24.897c3.056-19.771 2.201-39.949-2.515-59.391l-7.906-32.594c-3.413-14.07-12.045-26.318-24.148-34.263-9.786-6.424-21.236-9.846-32.942-9.846h-31.11l10.841 40.459z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.041 44.739h-36.276l.001.003c-3.715.042-7.512.68-11.278 1.995-9.362 3.268-17.634 9.068-23.898 16.755l-2.67 3.278h56.48z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.616 73.675-2.3.823c-16.601 5.937-27.67 21.677-27.642 39.308.018 11.85 9.536 21.136 20.872 21.425l.001.007h30.029l49.296-61.563z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.254 465.91h20.52c7.172 0 12.986-5.814 12.986-12.986v-101.685l-24.606-8.128-8.901 27.474v95.325z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.096 465.91h17.966c7.172 0 12.986-5.814 12.986-12.986v-81.482l-30.953 20.142v74.326z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.463 268.155c0-20.321-16.752-36.73-37.2-36.169-19.708.541-35.166 17.206-35.166 36.922v122.674c12.236 0 23.506-6.651 29.419-17.364l1.533-2.778 24.344-69.389c.839-2.391 2.238-4.572 4.176-6.204 7.884-6.637 12.894-16.579 12.894-27.692z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.163 285.175c-.608-4.673.16-9.415 2.18-13.672 3.094-6.519 4.785-13.833 4.684-21.552-.337-25.793-21.134-47.149-46.911-48.127-27.825-1.056-50.715 21.189-50.715 48.779 0 9.899 2.947 19.111 8.011 26.804l57.841 93.178c10.64 0 20.756-4.621 27.721-12.664l5.786-6.681z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.86 484.595h32.809v-18.685h-18.574c-2.839 0-5.439 1.587-6.738 4.111z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.605 484.595h32.809v-18.685h-18.574c-2.839 0-5.439 1.587-6.738 4.111z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.302 465.91h-10.461c-2.839 0-5.439 1.587-6.738 4.111l-7.498 14.574h10.461l7.498-14.574c1.299-2.525 3.899-4.111 6.738-4.111z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.018 484.595h34.756v-18.685h-20.521c-2.839 0-5.439 1.587-6.738 4.111z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.763 484.595h34.756v-18.685h-20.52c-2.839 0-5.439 1.587-6.738 4.111z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.46 465.91h-10.461c-2.839 0-5.439 1.587-6.738 4.111l-7.498 14.574h10.461l7.498-14.574c1.298-2.525 3.899-4.111 6.738-4.111z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.163 383.216h-2.41c-5.656 0-10.241-4.585-10.241-10.241v-158.44c7.839 4.618 12.65 13.038 12.65 22.136v146.545z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.862 245.345c0-32.58-26.411-58.991-58.991-58.991h-138.808c-20.958 0-39.029-14.731-43.254-35.258l-14.776-71.79c-4.004-19.454-21.13-33.414-40.992-33.414l-21.501 4.421-8.942 53.913 7.303 113.784c0 59.908 41.263 109.195 101.171 109.195h48.336c28.471 0 56.755-4.598 83.759-13.617l27.704-9.252c32.58 0 58.991-26.411 58.991-58.991z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444.19 211.497-52.281 18.904c-20.671 7.475-34.56 27.266-34.56 49.248v37.296c-3.443.988-6.904 1.906-10.38 2.752v-40.048c0-26.339 16.641-50.052 41.41-59.01l48.623-17.581c2.649 2.578 5.058 5.404 7.188 8.439zm-234.88-82.262-78.948 18.044-2.763 11.28 83.805-19.154zm16.77 44.426c-2.659-2.617-4.994-5.576-6.932-8.818l-88.652 25.273-2.898 11.62zm49.796 12.693-17.969 45.434c-10.571 26.727-15.931 54.852-15.931 83.594v11.824h10.38v-11.824c0-27.429 5.115-54.269 15.203-79.777l19.479-49.25h-11.162zm-31.599-1.886c-3.924-1.187-7.633-2.908-11.032-5.087l-80.028 53.886s-19.559 21.48-18.262 24.812zm79.794 69.408c0-16.999 10.076-32.354 25.67-39.119l61.07-26.494c-4.771-1.245-9.778-1.909-14.939-1.909h-6.744l-43.518 18.879c-19.39 8.413-31.919 27.506-31.919 48.643v71.702c3.469-.387 6.93-.842 10.38-1.365zm-28.478 73.091v-77.012c0-21.455 8.356-41.627 23.526-56.799l6.803-6.803h-14.674c-16.795 17.07-26.036 39.626-26.036 63.602v77.247c3.464-.01 6.925-.088 10.381-.235zm-30.321-140.613h-8.208c-1.625 0-3.232-.089-4.817-.262l-77.782 98.416-3.411 21.058z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.252 218.731v-24.023l-3.806-4.976 3.806-5.818v-30.99l-3.569-2.507 3.569-8.141v-38.05l8.942-53.913 10.458-2.15c-4.287-1.475-8.871-2.27-13.61-2.27l-21.501 4.421-8.942 53.913v43.685l3.501 4.514-3.501 6.134v32.383l3.955 3.542-3.955 7.252v16.994c0 10.089 1.377 19.857 3.954 29.124l3.341 3.184.061 7.04c6.129 15.738 15.825 29.692 28.096 40.868 0 0 4.732-1.036 6.424.329.846.683 1.094 5.925 1.094 5.925 18.201 13.809 40.895 22.003 65.503 22.003h24.654c-31.367 0-59.625-13.314-79.43-34.599 0 0-3.811.935-5.246-.814-.806-.982-1.585-7.284-1.585-7.284-8.956-11.728-15.575-25.336-19.162-40.129 0 0-2.648-.316-3.05-2.607-.25-1.429.966-8.505.966-8.505-.638-4.753-.967-9.606-.967-14.535z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.252 194.708-24.654 7.028v-10.794l24.654-7.028zm-17.296 63.371 20.346-13.7c-.881-3.636-1.58-7.343-2.085-11.111l-21.665 14.588c.969 3.481 2.107 6.892 3.404 10.223zm17.296-115.802-24.654 5.635v10.648l24.654-5.635zm89.724 183.313v1.615h10.38v-.318c-3.509-.268-6.972-.703-10.38-1.297zm-78.924-26.642c2.558 2.33 5.228 4.539 8.001 6.619l10.243-12.96c-2.405-2.585-4.685-5.287-6.832-8.098z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.224 129.772c18.62-3.283 32.076-19.635 31.714-38.538l-.103-5.385c-.459-23.994-24.229-40.533-46.887-32.623-4.202 1.467-8.185 3.444-11.865 5.873l-7.485 45.128v31.651z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.841 465.91h17.966c7.172 0 12.986-5.814 12.986-12.986v-81.482l-30.953 20.142v74.326z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.699 383.216-12.858 8.366v74.328h12.858z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409.999 465.91h20.52c7.172 0 12.987-5.814 12.987-12.986v-101.685l-24.606-8.128-8.901 27.474z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.959 344.121-3.059-1.01-8.901 27.474v95.325h11.688v-120.769z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.208 268.155c0-20.321-16.752-36.73-37.2-36.169-19.708.541-35.166 17.206-35.166 36.922v122.674c12.236 0 23.506-6.651 29.419-17.364l1.533-2.778 24.344-69.389c.839-2.391 2.238-4.572 4.176-6.204 7.884-6.637 12.894-16.579 12.894-27.692z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.581 268.87c0-17.906 12.763-33.25 29.841-36.333-2.337-.417-4.752-.61-7.222-.555-19.779.441-35.359 17.105-35.359 36.888v122.713h.133c7.009-.028 12.607-5.88 12.607-12.889z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.908 285.175c-.608-4.673.16-9.415 2.18-13.672 3.094-6.519 4.785-13.833 4.684-21.552-.337-25.793-21.134-47.149-46.911-48.127-27.825-1.056-50.715 21.189-50.715 48.779 0 9.899 2.947 19.111 8.011 26.804l57.841 93.178c10.64 0 20.756-4.621 27.721-12.664l5.786-6.681z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.051 277.407c-5.064-7.694-8.011-16.905-8.011-26.804 0-24.771 18.45-45.232 42.358-48.391-1.493-.198-3.006-.329-4.537-.387-27.825-1.056-50.715 21.189-50.715 48.779 0 9.899 2.947 19.111 8.011 26.804l57.841 93.178c4.023 0 7.971-.661 11.703-1.918z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.994 52.488h-17.927l-3.089-51.485c0-.847.986-1.312 1.639-.773l2.428 2.004c10.733 8.856 16.948 22.044 16.948 35.959v14.295z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.978 1.004v44.227h11.088v-14.295c0-11.132-3.978-21.798-11.064-30.154-.016.071-.024.145-.024.222z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.45 84.746-.103-5.385c-.459-23.994-24.229-40.533-46.887-32.623-9.362 3.268-17.634 9.068-23.897 16.755l-2.671 3.278-19.304 6.904-6.052 22.635c-1.651 6.177 1.61 12.607 7.568 14.924 7.506 2.919 10.729 11.777 6.853 18.837l-1.532 2.79 54.311-9.576c18.619-3.284 32.076-19.636 31.714-38.539z",
    fill: "url(#SVGID_35_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.104 111.234c-5.959-2.317-9.22-8.747-7.568-14.924l6.051-22.635-2.3.823c-16.601 5.937-27.67 21.677-27.642 39.308.021 13.329 12.06 23.415 25.186 21.1l11.594-2.044 1.532-2.79c3.876-7.061.653-15.919-6.853-18.838z",
    fill: "url(#SVGID_36_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZebra);
export default __webpack_public_path__ + "static/media/icon-zebra.99391ca6e4d044ad8507510528ea44ae.svg";
export { ForwardRef as ReactComponent };